module.exports = __webpack_public_path__ + "img/5.6a12d947.png";